export class CsvFormatter {
  static escape(value: string): string {
    let escaped = value;
    
    if (escaped.includes('"')) {
      escaped = escaped.replace(/"/g, '""');
    }
    
    if (escaped.includes(',') || escaped.includes('\n') || escaped.includes('"')) {
      escaped = `"${escaped}"`;
    }
    
    return escaped;
  }

  static createCsvContent(headers: string[], rows: string[][]): string {
    const csvRows: string[] = [];
    csvRows.push(headers.map(h => this.escape(h)).join(','));
    rows.forEach(row => {
      csvRows.push(row.map(cell => this.escape(cell)).join(','));
    });
    return csvRows.join('\n');
  }

  static download(content: string, filename: string): void {
    const csvFile = new Blob([content], { type: 'text/csv' });
    const csvUrl = URL.createObjectURL(csvFile);

    const link = document.createElement('a');
    link.href = csvUrl;
    link.download = `${filename}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    URL.revokeObjectURL(csvUrl);
  }
}
